export default __webpack_public_path__ + "static/media/step3.df4cc382.svg";